export const ITEMS_PER_PAGE_OPTIONS = [20, 50, 100] as const
export type ItemsPerPageOptions = (typeof ITEMS_PER_PAGE_OPTIONS)[number]
